import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import { FeatureFlagsContext } from '@core-ui/feature-flags';
import { Brands } from '@core-ui/react-stitch';

export const useBRRedesign = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const { enabledFeatures } = useContext(FeatureFlagsContext);

  return !!([Brands.BananaRepublic, Brands.BananaRepublicFactoryStore].includes(abbrBrand) && enabledFeatures['seo-br-redesign']);
};
